import { render } from "./WindowError.vue?vue&type=template&id=00ef86a2&scoped=true"
import script from "./WindowError.vue?vue&type=script&lang=js"
export * from "./WindowError.vue?vue&type=script&lang=js"

import "./WindowError.vue?vue&type=style&index=0&id=00ef86a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ef86a2"]])

export default __exports__